import { jsx as _jsx } from "react/jsx-runtime";
import { DraggableComponentTypes, } from "../../../types/draggable";
import DraggableBox from "../DraggableBox";
const DraggableGridItem = ({ id, children, elementId, props, }) => {
    return (_jsx(DraggableBox, { editorKey: id, draggableId: id, elementId: elementId, childs: children, className: props?.className, type: DraggableComponentTypes.GridItem }));
};
export default DraggableGridItem;
//# sourceMappingURL=DraggableGridItem.js.map